async function fetchNextPage(url) {
  try {
    const response = await fetch(url);
    return await response.text();
  } catch (error) {
    console.error("Error fetching page:", error);
  }
}

const productGridElement = document.getElementById('product-grid');
let nextPageUrl = productGridElement.dataset.nextUrl;

function observeMutations() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const foundElements = node.querySelectorAll('ul[data-next-url]');
          foundElements.forEach((el) => {
            nextPageUrl = el.getAttribute('data-next-url')
          });
        }
      });
    });
  });

  observer.observe(document.getElementById('MainContent'), { childList: true, subtree: true });
}

function addBanner (currentProductCount, productsPerPage) {

  const plpBanners = document.querySelectorAll("#plp-banners-wrapper > [id^='plp-banner-section-']")

  if (plpBanners.length === 0) {
    return;
  }

  let productsWithBannerAdded = currentProductCount;

  for (let plpBanner of plpBanners) {

    let elementsNotBanner = productGridElement.querySelectorAll("li:not([id^='plp-banner-section-'])");
    let currentElement = elementsNotBanner[plpBanner.getAttribute('data-position') - 1];

    if (currentElement) {

      const elmSiblings = getSiblings(currentElement)

      let elementsBefore = elmSiblings.before.length

      for (let elmSibling in elmSiblings.before) {
        if (elmSiblings.before[elmSibling].classList.contains('plp_banner-double--width')) {
          elementsBefore = elementsBefore + 1;
        }
      }

      if (elementsBefore % 2 === 0) {
        productGridElement.insertBefore(plpBanner, currentElement);
        productsWithBannerAdded = productsWithBannerAdded + 1;
      } else {
        productGridElement.insertBefore(plpBanner, currentElement.nextSibling);
        productsWithBannerAdded = productsWithBannerAdded + 1;
      }
      plpBanner.classList.remove("plp_banner");
    }
  }

  const doubleWidthBanner = productGridElement.querySelectorAll(".plp_banner-double--width")
  const singleWidthBanner = productGridElement.querySelectorAll(".plp_banner-single--width")

  let productsToLoad = 0

  if(productsWithBannerAdded >= parseInt(productsPerPage) && ((doubleWidthBanner.length * 2 + singleWidthBanner.length) % 4) > 0) {
    productsToLoad = (4 - ((doubleWidthBanner.length * 2 + singleWidthBanner.length) % 4));
  }

  document.getElementById('loadMoreProducts').setAttribute('data-load-more-products', productsToLoad.toString())
}

function fillProductsForBannerSpace () {

  const elements = document.getElementsByClassName('product-banner-fill');
  while(elements.length > 0){
    elements[0].parentNode.removeChild(elements[0]);
  }

  const productsCount = document.getElementById('loadMoreProducts').getAttribute('data-load-more-products')
  const productGrid = document.getElementById('product-grid')

  if(productsCount > 0) {
    fetch(nextPageUrl)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const newProducts = doc.querySelectorAll('#product-grid .grid__item');

        for (let i = 0; i < productsCount; i++) {
          const node = newProducts[i].cloneNode(true);
          node.classList.add('product-banner-fill')
          productGrid.appendChild(node)
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

const getSiblings = (elm, withTextNodes) => {
  if (!elm || !elm.parentNode) return

  let siblings = [...elm.parentNode[withTextNodes ? 'childNodes' : 'children']],
    idx = siblings.indexOf(elm);

  siblings.before = siblings.slice(0, idx)
  siblings.after = siblings.slice(idx + 1)

  return siblings
}


async function loadMoreProducts(totalProductCount, productsPerPage) {
  const productsContainer = document.getElementById('product-grid');
  const loadMoreButton = document.querySelector('.load-more_btn');

  try {
    loadMoreButton.style.display = 'none';
    const nextPageHTML = await fetchNextPage(nextPageUrl);
    const parser = new DOMParser();
    const doc = parser.parseFromString(nextPageHTML, 'text/html');
    const newProducts = doc.querySelectorAll('#product-grid .grid__item');
    nextPageUrl = doc.querySelector('#product-grid').dataset.nextUrl;
    loadMoreButton.style.display = nextPageUrl ? 'inline-flex' : 'none';

    newProducts.forEach(product => productsContainer.appendChild(product.cloneNode(true)));

    addBanner(newProducts.length, productsPerPage);
    fillProductsForBannerSpace();

    setProgressBar(totalProductCount)

    initializeScrollAnimationTrigger();
    initializeScrollZoomAnimationTrigger();
    
  } catch (error) {
    console.error("Error loading more products:", error);
  }
}

function setProgressBar (totalProductCount) {
  const productCountElement = document.querySelector('.load_more_product_count');
  const productsContainer = document.getElementById('product-grid');
  const progressBar = document.querySelector('.load-more-progressbar > div');
  productCountElement.textContent = productsContainer.querySelectorAll("li:not([id^='plp-banner-section-'])").length.toString()
  progressBar.style.width = `${(productsContainer.childElementCount / totalProductCount) * 100}%`;
}

observeMutations();

